export var orderedButtonStyle = function orderedButtonStyle(_ref) {
  var toolkit = _ref.toolkit;
  var spacing = toolkit.spacing;

  var createDensityStyle = function createDensityStyle(density) {
    var spacingMixin = spacing[density].spacing;
    return {
      '&$orderedButton': {
        margin: spacingMixin(0, 1, 0, 0),
        '&:last-child': {
          margin: 0
        },
        '&$alignLeft': {
          marginRight: 'auto'
        },
        '&$alignRight': {
          marginLeft: 'auto'
        },
        '&$stacked': {
          margin: spacingMixin(0, 0, 1, 0),
          '&:last-child': {
            margin: 0
          }
        }
      }
    };
  };

  return {
    stacked: {},
    orderedButton: {
      '&:last-child': {
        marginRight: 0
      }
    },
    alignRight: {},
    alignLeft: {},
    highDensity: createDensityStyle('high'),
    mediumDensity: createDensityStyle('medium'),
    lowDensity: createDensityStyle('low'),
    touchDensity: createDensityStyle('touch')
  };
};